// Module
var code = "<div class=\"row\"> <h1 class=\"page-header\"> Account Page </h1> </div> ";
// Exports
module.exports = code;